export default "__VITE_PUBLIC_ASSET__f5e5deba__"